import React,{useContext, useEffect, useRef} from 'react'
import CategoriesSideBar from "../../components/CategoriesSideBar"
import Categories from '../../components/Categories'
import Products from '../../components/Product'
import AppContext from "../../context";
import "./styles.css"
import BannerProductImg from "../../components/BannerProductImg"
import CarouselProductsTopSale from "../../components/CarouselProductsTopSale"


 const Shop:React.FC = () => {
    const data = useContext(AppContext.AppCtx); 
    const Ref = useRef<HTMLHeadingElement>(null)
    const {setPositionY, yPosition} = data
    useEffect(() => {
      const handleScroll = () => {
        const div:any = Ref.current;
        const { y } = div.getBoundingClientRect();
        setPositionY(y)
      };
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);

    const categories: { name: string; img: string }[] = data.Categories
    const products :{name: string; img: string, price:number}[] = data.products
    
  return (
    <div ref={Ref} className='shop'>
        <div className="headerBackground"></div>
        <div className='body_container'>
        {/* <SideBarSHop/> */}
        <div className='sideBar'>
          <h3>CATEGORIAS</h3>
          <div className='scroll'>
        {categories ? (
          categories.map((category) => <CategoriesSideBar key={category.name} category={category} />)
        ) : (
          <></>
        )}
        </div>
        </div>
        <div className='containerCategorySelected'>
          <h2>PROTEINAS</h2>
        <div  className='containerProducts'>
        {products ? (
          products.map((product) => <Products  product={product} />)
        ) : (
          <></>
        )}
        </div>
        </div>
        </div>
        <CarouselProductsTopSale/>
        <BannerProductImg img={"https://res.cloudinary.com/ddoltb8nf/image/upload/v1664058169/just/Banner3_xlo332.jpg"}/>
    </div>
  )
}


export default Shop